import AvatarModal from './components/modals/AvatarModal'

export default function () {
  return { component: AvatarModal }
}
